import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Wrench, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

const Maintenance = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 font-quicksand relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-auxis-charcoal" />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-lg w-full bg-white rounded-3xl shadow-soft-xl p-10 md:p-12 text-center relative z-10 border border-gray-100"
      >
        <motion.div 
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5, type: "spring" }}
          className="relative w-24 h-24 mx-auto mb-8"
        >
          <div className="absolute inset-0 bg-auxis-gold/10 rounded-full animate-pulse" />
          <div className="absolute inset-2 bg-auxis-gold/20 rounded-full flex items-center justify-center">
            <Wrench className="w-10 h-10 text-auxis-gold" />
          </div>
          <motion.div 
            animate={{ rotate: 360 }}
            transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
            className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow-sm flex items-center justify-center border border-gray-50"
          >
            <Clock className="w-4 h-4 text-auxis-charcoal/60" />
          </motion.div>
        </motion.div>
        
        <span className="inline-block px-4 py-1.5 mb-4 text-xs font-bold uppercase tracking-widest text-auxis-gold bg-auxis-gold/10 rounded-full">
          En construction
        </span>

        <h1 className="text-3xl md:text-4xl font-bold text-auxis-charcoal mb-4 tracking-tight">
          Bientôt Disponible
        </h1>
        
        <p className="text-auxis-charcoal/60 mb-10 leading-relaxed text-lg">
          Nos réseaux sociaux sont actuellement en cours de configuration pour vous offrir la meilleure expérience. 
          Revenez très bientôt pour suivre nos actualités !
        </p>
        
        <Link 
          to="/" 
          className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-auxis-charcoal text-white rounded-xl font-semibold hover:bg-auxis-gold transition-all duration-300 shadow-md hover:shadow-lg w-full sm:w-auto"
        >
          <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform duration-300" />
          Retourner à l'accueil
        </Link>
      </motion.div>
    </div>
  );
};

export default Maintenance;